<template>
  <div class="pp-breadcrumb">
    <span
      v-for="(crumb, index) in crumbs"
      :key="index"
      @click="navigate(crumb.path)"
    >
      {{ $t(crumb.name) }}
    </span>
  </div>
</template>

<script>
export default {
  name: "Breadcrumb",
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  computed: {
    crumbs() {
      const paths = [
        {
          path: "/",
          name: "pp:breadcrumb.home",
        },
      ];
      return paths.concat(this.items);
    },
  },
  methods: {
    navigate(path) {
      if (path) {
        this.$router.push(path).catch((failure) => {
          console.error(failure);
          this.$buefy.toast.open({
            duration: 5000,
            message: `Navigation failed!`,
            position: "is-bottom",
            type: "is-danger",
          });
        });
      }
    },
  },
};
</script>

<style scoped></style>
